import { render, staticRenderFns } from "./OnboardingError.vue?vue&type=template&id=0832b154&"
import script from "./OnboardingError.vue?vue&type=script&lang=js&"
export * from "./OnboardingError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports